import { Fragment } from 'react'

const LoggedOutBox = () => {
  const redirectUrl = (target) => {
    const currentUrl = encodeURIComponent(window.location.href)
    window.location = `/${target}?redirect=${currentUrl}`
  }

  return (
    <Fragment>
      <div className="user-social">
        <button
          type="button"
          onClick={() => redirectUrl('login/facebook')}
          className="user-social-button user-social-button-facebook"
        >
          Iniciar sessão com o Facebook
        </button>
        <button
          type="button"
          onClick={() => redirectUrl('login/google')}
          className="user-social-button user-social-button-google"
        >
          Iniciar sessão com o Google
        </button>

        <button
          type="button"
          onClick={() => redirectUrl('login/apple')}
          className="user-social-button user-social-button-apple"
        >
          Iniciar sessão com a Apple
        </button>
        <span className="user-social-spacer">ou</span>
      </div>

      <div className="user-login">
        <button
          type="button"
          onClick={() => redirectUrl('login')}
          className="user-login-button"
        >
          Entrar
        </button>
        <span className="user-register user-social-link">
          Cliente novo?{' '}
          <a onClick={() => redirectUrl('cadastre-se')}>Cadastre-se</a>
        </span>
      </div>

      <div className="user-options">
        <a href="/minha-conta">Minha conta</a>
        <span className="spacing"></span>
        <a href="/minha-conta">Meus pedidos</a>
      </div>
    </Fragment>
  )
}

export default LoggedOutBox
